export type IntakeSite = {
  id: string;
  organization_id?: string | null;
};

/**
 * listMySites filtert nicht nach Verein. Zeilen ohne organization_id
 * bleiben, damit ältere Aufrufer nicht leer werden. Fremde Vereine fallen weg.
 */
export function sitesForOrganization<T extends IntakeSite>(
  sites: readonly T[],
  organizationId: string,
): T[] {
  return sites.filter(
    (site) => site.organization_id == null || site.organization_id === organizationId,
  );
}

/**
 * Schreibrecht ist die Menge der Stellen mit gültigem care_site_access.
 * null heißt: die Menge ist noch nicht bekannt (kein Nutzer, Tests). Dann bleibt die Liste.
 */
export function writableCareSites<T extends { id: string }>(
  sites: readonly T[],
  writableIds: ReadonlySet<string> | null,
): T[] {
  if (writableIds == null) return [...sites];
  return sites.filter((site) => writableIds.has(site.id));
}

/**
 * Zuletzt genutzte Stelle, wenn sie noch in der schreibbaren Auswahl liegt.
 * Sonst genau eine Stelle. Mehrere ohne Treffer bleiben leer.
 * Hand-Auswahl setzt der Aufrufer über siteTouched und ruft das hier nicht mehr auf.
 */
export function prefillCareSiteId(
  writableSites: readonly { id: string }[],
  lastUsedId: string | null,
): string | null {
  if (lastUsedId && writableSites.some((site) => site.id === lastUsedId)) {
    return lastUsedId;
  }
  if (writableSites.length === 1) return writableSites[0]?.id ?? null;
  return null;
}
